<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <div class="title">
        <div style="display: flex; align-items: center;justify-content: space-between;">
          <h3>券包管理</h3>
          <div style="display:flex">
            <!-- <div class="u-btn" @click="deleteS('lotsof')">批量删除</div> -->
            <el-button type="primary" @click="add('add')" icon="el-icon-plus" size="small">新增券包</el-button>
          </div>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
        <div style="height: 60px;"></div>
      </div>
      <el-dialog :title="optionsPush" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogPush"
        width="518px">
        <el-form ref="pForm" label-width="80px" class="info-form" :rules="rules1" :model="pForm">
          <el-form-item label="券包名称" prop="name">
            <el-input placeholder="请输入券包名称" v-model="pForm.name" style="width: 100%" show-word-limit max="8"></el-input>
          </el-form-item>
          <el-form-item label="关联场景" prop="activityId">
            <el-select style="width: 100%" v-model="pForm.activityId" placeholder="请选择关联场景">
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="pForm.status">
              <el-radio :label="1">启动</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="dialogPush = false">取消</div>
          <div class="info-s" @click="submitP">确定</div>
        </div>
      </el-dialog>
      <el-dialog :title="statusTitle" :visible.sync="isS" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
        <template>
          <div class="info" style="text-align: left" v-if="statusTitle == '禁用信息'">
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认禁用该优惠券？
          </div>
          <div class="info" style="text-align: left" v-else>
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认启用该优惠券？
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isS = false">取消</div>
            <div class="info-s" @click="submitA">确定</div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
        <template>
          <div class="info" style="text-align: left" v-if="isSingle != 'single'">
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认删除选中的{{ deleteIds.length }}个优惠券？
          </div>
          <div class="info" style="text-align: left" v-else>
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认删除该券包？
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isD = false">取消</div>
            <div class="info-s" @click="submitD">确定</div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="生成二维码" :visible.sync="isQcode" width="518px" :append-to-body="true">
        <template>
          <div style="margin-left: 139px;">
            <img :src="qCode" style="width: 200px;height: 200px;" />
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-s"><a :href="qrInfoDown" style="color:white;text-decoration: none;">导出</a>
            </div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="券包明细" :visible.sync="isPackageD" width="848px" :append-to-body="true">
        <template>
          <div>
            <el-table :data="tableData" tooltip-effect="dark" row-key="id" ref="multipleTable"
              :header-cell-style="{ 'background': '#f8f8f8', 'color': '#333333' }" style="width: 100%;">
              <el-table-column label="排序" width="80px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="关联优惠券" prop="name" width="400px">
              </el-table-column>
              <el-table-column prop="personelQuantity" label="关联数量">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" v-if="scope.$index > 0" @click="toUp(scope.$index)">上移</el-button>
                  <el-button size="mini" type="text" v-if="scope.$index < tableData.length - 1"
                    @click="toDown(scope.$index)">下移</el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isPackageD = false">取消</div>
            <div class="info-s" @click="submitC">确定</div>
          </div>
        </template>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data() {
    return {
      isPackageD: false,
      dialogPush: false,
      optionsPush: '新增券包',
      couponForm: {
        couponId: '',
        num: null,
        userSelectType: '0'
      },
      rules: {
        couponId: [
          { required: true, message: '请选择发放卡券', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入发放数量', trigger: 'blur' }
        ],
      },
      pForm: {
        activityId: '',
        name: '',
        id: '',
        status: 1,
      },
      rules1: {
        name: [
          { required: true, message: '请输入券包名称', trigger: 'blur' },
        ],
        activityId: [
          { required: true, message: '请选择关联场景', trigger: 'change' }
        ],
      },
      coupons: [],
      fcoupons: [],
      keywords: '',
      tableData: [],
      tableData1: [],
      form: {
        userSelectType: '0'
      },
      isCoupon: false,
      isQcode: false,
      qCode: '',
      isD: false,
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '券包管理', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '',
        typeFlag: '',
        pageNo: 1,
        pageSize: 10,
        // bindUserInfo: null,
        categoryId: ''
      },
      openTime: [],
      statuss: [
        {
          id: '1',
          name: '已启用'
        },
        {
          id: '0',
          name: '已禁用'
        }
      ],
      list: [

      ],
      columns: [
        // { type: 'selection', width: '80', fixed: 'left' },
        { label: '排序', prop: 'sort', width: '80' },
        { label: '券包名称', prop: 'name', minWidth: '120' },
        {
          label: '关联场景', prop: 'activityName', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p style="max-height: 120px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;">{scope.row.activityName ? scope.row.activityName : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '关联优惠券', prop: 'name', minWidth: '240',
          render: (h, scope) => {
            let v = ''
            let d = ''
            if (scope.row.couponList && scope.row.couponList.length > 0) {
              v = <div style="width:210px;text-align:left;max-height: 60px;line-height:30px;overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">
                {
                  scope.row.str
                }
              </div>
              d = <div>
                <div style="width: 64px;height: 24px;background: #FFFFFF;border-radius: 3px;border: 1px solid #2D46EE;font-family: Microsoft YaHei;font-weight: 400;font-size: 12px;color: #2D46EE;line-height: 24px;text-align: center;cursor:pointer">查看明细</div>
              </div>
            } else {
              v = '--'
              d = ' '
            }
            return (
              <div style="display:flex;justify-content:space-between;align-items:center">
                <div>{v}</div>
                <div style="text-align:left" onClick={() => { this.toPackage(scope.row) }}>{d}</div>
              </div >

            )
          }
        },
        { label: '关联优惠券种类', prop: 'count', minWidth: '120' },
        {
          label: '状态', prop: 'statusLabel', minWidth: '130',
          render: (h, scope) => {
            let vv = ''
            if (scope.$index == 0) {
              vv = '--'
            } else {
              vv = <div>
                <el-switch
                  onChange={() => { this.isChangeStatus(scope.row) }}

                  v-model={scope.row.statusL}
                  active-color="#2D46EE"
                  inactive-color="#EBEEFA">
                </el-switch>
              </div>
            }
            return (
              <div>
                {vv}
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            let vv = ''
            if (scope.$index == 0) {
              vv = '--'
            } else if (scope.$index == 1 && scope.$index != this.list.length - 1) {
              vv = <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeSort(scope.row, scope.$index, 'down') }}>下移</span>
              </div>
            } else if (scope.$index == this.list.length - 1) {
              vv = <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeSort(scope.row, scope.$index, 'up') }}>上移</span>
              </div>
            } else if (scope.$index > 1 && scope.$index < this.list.length - 1) {
              vv = <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeSort(scope.row, scope.$index, 'up') }}>上移</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeSort(scope.row, scope.$index, 'down') }}>下移</span>
              </div>
            } else {
              vv = <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
              </div>
            }
            return (
              <div>{vv}</div>
              // <div>
              //   <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</span>
              //   <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
              //   <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeStatus(scope.row) }}>上移</span>
              //   <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.changeStatus(scope.row) }}>下移</span>
              // </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false,
      isSingle: 'single',
      isS: false,
      deleteIds: [],
      selectionCoupons: [],
      qrInfo: '',
      qUrl: '',
      qrInfoDown: '',
      cPageNo: 1,
      cPageSize: 6,
      cTotalNum: 0,
      cPageNo1: 1,
      cPageSize1: 6,
      selectTemArr: [],
      pageData: [],
      categoryIds: [],
      allValues: [], // 用于存储所有可能的值
      pType: '',
      statusTitle: '',
      cId: '',
      cStatus: '',
      userList: []
    }
  },
  created() {
    // this.getCategoryList()
    this.getDictionaries('recommend_type')
    // this.getList()
    this.getUList()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'couponDetail') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },
  mounted() {

  },
  methods: {
    toUp(index) {
      this.tableData.splice(index, 1, ...this.tableData.splice(index - 1, 1, this.tableData[index]));
      console.log(index, this.tableData)
      this.$forceUpdate()
    },
    toDown(index) {
      this.tableData.splice(index + 1, 1, ...this.tableData.splice(index, 1, this.tableData[index + 1]));
      this.$forceUpdate()
    },
    toPackage(row) {
      this.isPackageD = true
      this.tableData = row.couponList
      // this.getPdetail(row.id)
    },
    getUList() {
      let data = {
        pageNo: 1,
        pageSize: 99999,
        status: 1
      }
      this.axios.post('/marketActivate/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.userList = res.data.list;
          }
        })
    },
    changeSort(row, index, type) {
      let arr = []
      if (type == 'up') {
        let obj = {
          id: row.id,
          sort: this.list[index - 1].sort
        }
        arr.push(obj)
        let obj1 = {
          id: this.list[index - 1].id,
          sort: row.sort
        }
        arr.push(obj1)
      } else {
        let obj = {
          id: row.id,
          sort: this.list[index + 1].sort
        }
        arr.push(obj)
        let obj1 = {
          id: this.list[index + 1].id,
          sort: row.sort
        }
        arr.push(obj1)
      }
      let data = {
        requestList: arr
      }
      this.axios.post('/couponPackage/sort', arr).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getList();
        }
      })
    },
    isChangeStatus(row) {
      let data = {
        id: row.id,
      }
      this.axios.post('/couponPackage/changeStatus', data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getList();
        }
      })
    },
    changeCoupon(e) {
      console.log(e)
      this.fcoupons.forEach(item => {
        if (item.id == e) {
          this.pForm.name = item.name
        }
      })
      console.log(this.pForm.name)
    },
    submitA() {
      let data = {
        id: this.cId,
        status: this.cStatus
      }
      this.axios.post('/couponRecommend/changeStatus', data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.isS = false
          this.getList();
        }
      })
    },
    //更改状态
    changeStatus(row) {
      this.isS = true
      this.cId = row.id;

      if (row.status == 1) {
        this.statusTitle = '禁用信息'
        this.cStatus = 1
      } else {
        this.statusTitle = '启用信息'
        this.cStatus = 0
      }
    },
    flattenOptions(options) {
      options.forEach((option) => {
        if (option.level == 3 || (option.level == 2 && !option.children) || (option.level == 1 && !option.children)) {
          this.allValues.push(option.id);
        }
        // this.allValues.push(option.id);
        if (option.children) {
          this.flattenOptions(option.children);
        }
      });
    },
    selectCType(e) {
      // console.log(e, this.allValues.length)
      if (this.allValues.length === e.length) {
        console.log('全选了');
        this.pForm.categoryType = 1
      } else {
        console.log('未全选');
        this.pForm.categoryType = 2
      }
    },
    getCategoryList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        // categoryName: '',
        // categoryNo: '',
        // status: null
      }
      this.axios.post('/category/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.categoryIds = res.data.list
            this.flattenOptions(this.categoryIds)
          }
        })
    },
    submitP() {
      this.$refs['pForm'].validate((valid) => {
        if (valid) {
          this.axios.post('/couponPackage/addEdit', this.pForm)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                if (this.pType == 'add') {
                  this.$message.success('新增成功')
                } else {
                  this.$message.success('编辑成功')
                }
                this.getList();
                this.dialogPush = false
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitC() {
      let arr = []
      this.tableData.forEach((item, index) => {
        let obj = {
          id: item.id,
          sortInPackage: index + 1
        }
        arr.push(obj)
      })
      this.axios.post('/couponPackage/changeCouponSort', arr)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('保存成功')
            this.isPackageD = false
          }
        })
    },
    del(index, row) {
      this.tableData1.splice(index, 1)
      let arr = []
      arr.push(row)
      arr.forEach((item) => {
        this.$refs.multipleTable.toggleRowSelection(item, false);
      });
      // this.$nextTick(() => {
      //   this.tableData.forEach(item => {
      //     if (item.id == row.id) {
      //       this.$refs.multipleTable.toggleRowSelection(item, false)
      //     }

      //   })
      // })
      this.pageData = this.queryByPage()
    },
    getfindVipCustomerPage() {
      this.cPageNo = 1
      this.getUser()
    },
    // 实现分页的方法
    queryByPage() {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.cPageNo1 - 1) * this.cPageSize1
      // 结束位置 = 当前页 x 每页的大小
      const end = this.cPageNo1 * this.cPageSize1

      return this.tableData1.slice(start, end)
    },
    handleSelectionChange(val) {
      console.log(val)
      // this.tableData1 = Array.from(new Set(val.concat(this.tableData1)))
      this.tableData1 = val.reverse()
      this.pageData = this.queryByPage()
    },
    cHandleCurrentChange1(currentChange) {
      this.cPageNo1 = currentChange
      this.pageData = this.queryByPage()
    },
    cHandleSizeChange1(sizeChange) {
      this.cPageSize1 = sizeChange
      this.pageData = this.queryByPage()
    },
    selectType(val) {
      this.form.userSelectType = val
    },
    fCoupon() {
      this.isCoupon = true
      this.keywords = ''
      this.tableData1 = []
      this.pageData = this.queryByPage()
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          this.$refs.multipleTable.toggleRowSelection(item, false)
        })

      })
      this.couponForm.couponId = ''
      this.couponForm.num = ''
      this.getUser()
      this.axios.post('/coupon/pageList', {
        pageNo: 1,
        pageSize: 100000,
      }).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.showFlag == 1) {
              item.showFlagL = '是'
            } else {
              item.showFlagL = '否'
            }
          })
          this.coupons = res.data.list
        }
      })
    },
    getUser() {
      this.axios.get('/user/search/list?keywords=' + this.keywords + '&pageNo=' + this.cPageNo + '&pageSize=' + this.cPageSize).then(res => {
        if (res.code == 0) {
          if (res.data.list.length > 0) {
            this.tableData = res.data.list
            this.cTotalNum = res.data.totalNum
          } else {
            this.tableData = []
            this.cTotalNum = 0
          }
        }
      })
    },
    deliveDetail(id) {
      this.$router.push({
        name: 'receiveDetail',
        query: {
          id: id
        }
      })
    },
    exportPng() {
      this.axios.get('/coupon/getCouponQrInfoDown?qrInfo=' + encodeURI(this.qrInfo)).then(res => {
        if (res.code == 0) {
          // this.qCode = res.data.url
        }
      })
    },
    lookQCode(qrInfo, qrInfoDown) {
      this.qrInfo = qrInfo
      this.qrInfoDown = qrInfoDown
      this.isQcode = true
      this.axios.post('/coupon/getCouponQrInfo', { qrInfo: qrInfo }).then(res => {
        if (res.code == 0) {
          this.qCode = res.data.url
        }
      })
    },
    deleteS(type, id) {

      this.isSingle = type
      this.deleteIds = []
      if (this.isSingle == 'single') {
        this.isD = true
        this.deleteIds.push(id)
      } else {

        if (this.selectionCoupons.length == 0) {
          this.$message.warning('请选择优惠券')
        } else {
          this.isD = true
          this.selectionCoupons.forEach(item => {
            this.deleteIds.push(item.id)
          })
        }
      }
    },
    submitD() {
      let data = {
        ids: this.deleteIds
      }
      this.axios.post('/couponPackage/delete/' + this.deleteIds[0]).then(res => {
        if (res.code == 0) {
          this.isD = false
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    //导出
    deriveDeliver() {
      this.$api.exportPlatformsList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory() {

    },
    onMultipleSelection(val) {
      this.selectionCoupons = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    cHandleCurrentChange(currentChange) {
      this.cPageNo = currentChange
      this.getUser()
    },
    cHandleSizeChange(sizeChange) {
      this.cPageSize = sizeChange
      this.getUser()
    },
    getList(type) {
      // if (type == 'reset') {
      //   this.searchForm = {}
      //   this.searchForm.pageNo = 1
      //   this.searchForm.pageSize = 10
      // }
      // if (type == 'search') {
      //   this.searchForm.pageNo = 1
      //   this.searchForm.pageSize = 10
      // }
      this.axios.get('/couponPackage/couponPackageList').then(res => {
        if (res.code == 0) {
          res.data.forEach(item => {
            item.str = ''
            if (item.couponList.length != 0) {
              item.couponList.forEach(itm => {
                item.str += itm.name + ','
              })
            } else {
              item.str = '--'
            }
            if (item.status == 1) {
              item.statusL = true
            } else {
              item.statusL = false
            }
          })
          this.list = res.data
          // this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.axios.get('/getDictGroup?groupId=' + type).then((res) => {
        this.dictionaries['recommend_type'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // // 获取类目列表
    // getCategoryList() {
    //   const params = {}
    //   this.$api.categoryList(params).then((res) => {
    //     res.data.list.forEach(item => {
    //       if (item.children) {
    //         item.children.forEach(itm => {
    //           if (itm.children) {
    //             delete itm.children
    //           }
    //         })
    //       }
    //     })
    //     this.categoryList = res.data.list
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // },
    add(type, id) {
      this.dialogPush = true
      this.pType = type
      this.getcList()
      if (this.$refs['pForm']) {
        this.$refs['pForm'].clearValidate()
        this.$refs['pForm'].resetFields()
      }
      if (type == 'add') {
        this.optionsPush = '新增券包'
        this.pForm.activityId = ''
        this.pForm.status = 1
        this.pForm.name = ''
        this.pForm.id = ''
        // this.$refs['pForm'].clearValidate()
        // this.$refs['pForm'].resetFields()
        // if (this.$refs['pForm']) {
        //   this.$refs['pForm'].clearValidate()
        // }
      } else {
        this.optionsPush = '查看/编辑券包'
        this.pForm.id = id
        this.getPdetail(id)
      }

      // this.$router.push({
      //   name: 'recommendCouponDetail',
      //   query: {
      //     type: type,
      //     id: id
      //   }
      // })

    },
    getPdetail(id) {
      this.axios.get('/couponPackage/detail/' + id).then(res => {
        if (res.code == 0) {
          // res.data.recommendType = String(res.data.recommendType)
          this.pForm = res.data
          this.tableData = res.data.couponList
        }
      })
    },
    getcList() {
      this.axios.post('/couponRecommend/getCoupon', { name: '' }).then(res => {
        if (res.code == 0) {
          this.fcoupons = res.data
        }
      })
    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.optionC {
  .el-cascader-panel {
    .el-scrollbar:first-child {
      .el-checkbox {
        display: none;
      }
    }
  }
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
  color: #2d46ee;
  font-weight: 700;
}
</style>
<style scoped lang="scss">
.l-detail {
  width: 64px;
  height: 24px;
  background: #FFFFFF;
  border-radius: 3px;
  border: 1px solid #2D46EE;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #2D46EE;
  line-height: 24px;
  text-align: center;
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  // display: flex;
  // justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
  opacity: 1;
  text-align: center;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.u-btn {
  width: 92px;
  height: 34px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.c-btn {
  width: 106px;
  height: 36px;
  background: #FF9226;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  